import { Component, computed, inject, input, output } from '@angular/core';
import { LocationState } from '../../../locations/store/locations.store';
import { EnergyInterfacesStore } from '../../stores/energy-interfaces.store';
import { EnergyInterfaceListSection } from '../energy-interface-list-section/energy-interface-list-section';
import { Button } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { EnergyInterfaceListEmpty } from '../energy-interface-list-empty/energy-interface-list-empty';
import { EnergyInterfaceList } from '../energy-interface-list/energy-interface-list';
import { EnergyInterfaceListEntry } from '../energy-interface-list-entry/energy-interface-list-entry';
import { RouterLink } from '@angular/router';
import { LocationNamePipe } from '../../../locations/pipes/location-name-pipe';
import { LocationAddressPipe } from '../../../locations/pipes/location-address-pipe';
import { RandomColorPipe } from '../../../../shared/pipes/random-color-pipe';

@Component({
  selector: 'app-energy-interface-location',
  imports: [
    EnergyInterfaceListSection,
    Button,
    TranslocoPipe,
    EnergyInterfaceListEmpty,
    EnergyInterfaceList,
    EnergyInterfaceListEntry,
    RouterLink,
    LocationNamePipe,
    LocationAddressPipe,
    RandomColorPipe,
  ],
  templateUrl: './energy-interface-location.html',
})
export class EnergyInterfaceLocation {
  private energyInterfacesStore = inject(EnergyInterfacesStore);

  location = input.required<LocationState>();
  showHeader = input(true);
  organizationId = input.required<string>();

  clickCreate = output<string>();

  protected energyInterfaces = computed(() => {
    const locationId = this.location()?.id;
    return (
      this.energyInterfacesStore
        .filteredEnergyInterfaces()
        ?.filter((ei) => ei.data?.locationID === locationId) ?? []
    );
  });
}
